// extracted by mini-css-extract-plugin
export default {"form":"save-mapping_form__e+-kR","saveButton":"save-mapping_saveButton__MSQMK"};